module.exports = __webpack_public_path__ + "static/bg-0cef842e6d17fbe52092a1537ea8deec.jpg";